const forceOutsideClick = () => document.getElementById('root').click()

export default forceOutsideClick
